<template>
  <section :class="`popup ${showModal ? popupShowClass : ''}`" @click="toggleModal($event)">
    <div :class="`popup__container ${showModal ? popupContainerShowClass : ''}`">
      <button
      type="button"
      class="popup__button popup__close"
      title="Закрыть"
      ></button>
      <div class="popup__content">
        <div class="post-more-container">
          <statistic />
          <post-chart />
          <tonal-chart />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
// components
import Statistic from '@/components/statistic/Statistic.vue';
import PostChart from '@/components/postChart/PostChart.vue';
import TonalChart from '@/components/tonalChart/TonalChart.vue';

// libraries
import moment from 'moment';

export default {
  name: 'Modal',
  props: {
    showModal: {
      type: Boolean,
      required: true,
    },
    currentData: {
      type: Object,
    },
  },
  data() {
    return {
      popupShowClass: 'popup--show popup__close',
      popupContainerShowClass: 'popup__container--show',
      moment,
    };
  },
  methods: {
    toggleModal(event) {
      this.$root.$emit('toggleModal', { target: event.target });
    },
    // перенести в helper при рефакторинге
    sourceIcon(source) {
      if (source === 'vk') return 'icon-vk.svg';
      if (source === 'fb') return 'icon-fb.svg';
      if (source === 'gs') return 'icon-smi.svg';
      if (source === 'tw') return 'icon-tw.svg';
      return 'icon-stab.png';
    },
  },
  components: {
    Statistic,
    PostChart,
    TonalChart,
  },
};
</script>

<style>
  @import "./css/style.css";
</style>
